export default __webpack_public_path__ + "static/media/figuremap31.f3f8e5d8.png";